var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113432",
    "data-name": "Rectangle 113432",
    width: 59.006,
    height: 37.488,
    fill: "#d0d9de"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_334303",
    "data-name": "Group 334303",
    transform: "translate(7619 -29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114335",
    "data-name": "Rectangle 114335",
    width: 72,
    height: 72,
    transform: "translate(-7619 29)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_334299",
    "data-name": "Group 334299",
    transform: "translate(-7795.503 -500.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337484",
    "data-name": "Path 337484",
    d: "M0,.8A1.632,1.632,0,0,1,1.5.005Q1.816,0,2.134,0H33.789c1.971,0,2.268.3,2.268,2.268q0,13.813,0,27.626a6.965,6.965,0,0,1-.018.748A1.323,1.323,0,0,1,34.688,32a5.629,5.629,0,0,1-.633.018q-6.7,0-13.409,0c-1.417,0-1.742-.267-2.018-1.644a6.363,6.363,0,0,0-5.642-5.041,6.777,6.777,0,0,0-5.869,1.99A6.013,6.013,0,0,0,5.537,30.4c-.267,1.353-.6,1.612-1.981,1.614-.652,0-1.3,0-1.956,0A1.652,1.652,0,0,1,0,31.2Z",
    transform: "translate(183 550.308)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337473",
    "data-name": "Path 337473",
    d: "M38.356,16.882V7.863H47.44l6.83,9.019v1.144l-15.914-.314Z",
    transform: "translate(184.181 550.55)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332150",
    "data-name": "Group 332150",
    transform: "translate(183 550.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332149",
    "data-name": "Group 332149",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337475",
    "data-name": "Path 337475",
    d: "M37.1,19.062q0-5.325,0-10.649c0-.23-.006-.462.016-.691a1.324,1.324,0,0,1,1.537-1.394c1.957-.007,3.915,0,5.871,0,.748,0,1.5.009,2.245,0a1.651,1.651,0,0,1,1.362.618q4.686,5.609,9.377,11.215a1.5,1.5,0,0,1,.36,1c0,3.76,0,7.522-.005,11.282a1.219,1.219,0,0,1-1.148,1.338,4.13,4.13,0,0,1-1.318.01,1.236,1.236,0,0,1-1.258-1.2,6.469,6.469,0,0,0-6-5.49,6.567,6.567,0,0,0-7.132,4.865c-.009.037-.024.073-.032.11-.366,1.6-1.422,2.177-3.007,1.627a1.105,1.105,0,0,1-.777-.852,5.545,5.545,0,0,1-.091-1.028q-.009-5.382,0-10.764m8.684-2.136c1.611,0,3.223,0,4.834,0a1.149,1.149,0,0,0,.965-1.961L46.939,9.4a1.534,1.534,0,0,0-1.252-.591c-1.573.01-3.146,0-4.719.006-.926.005-1.325.4-1.33,1.339q-.014,2.7,0,5.41c0,.97.4,1.359,1.365,1.363,1.593.007,3.184,0,4.777,0",
    transform: "translate(1.142 0.194)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337476",
    "data-name": "Path 337476",
    d: "M11.864,36.646a5.048,5.048,0,1,1,5.08-5.013,5.015,5.015,0,0,1-5.08,5.013m1.387-5.038a1.373,1.373,0,1,0-2.745-.007,1.373,1.373,0,1,0,2.745.007",
    transform: "translate(0.209 0.817)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337477",
    "data-name": "Path 337477",
    d: "M47.32,36.647a5.049,5.049,0,0,1,.02-10.1,5.049,5.049,0,1,1-.02,10.1M47.339,33a1.443,1.443,0,0,0,1.413-1.376A1.489,1.489,0,0,0,47.38,30.2a1.439,1.439,0,0,0-1.431,1.415A1.422,1.422,0,0,0,47.339,33",
    transform: "translate(1.302 0.817)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337478",
    "data-name": "Path 337478",
    d: "M16.944,31.6a5.073,5.073,0,1,1-5.073-5.073A5.073,5.073,0,0,1,16.944,31.6",
    transform: "translate(0.209 0.816)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337479",
    "data-name": "Path 337479",
    d: "M52.425,31.6a5.073,5.073,0,1,1-5.073-5.073A5.073,5.073,0,0,1,52.425,31.6",
    transform: "translate(1.301 0.816)",
    fill: "#1a2024"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_332151",
    "data-name": "Group 332151",
    transform: "translate(186.092 554.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337480",
    "data-name": "Path 337480",
    d: "M22.307,2.591V4.443H18.441v2h2.892v1.8H18.441V12.08H16.128V2.591Z",
    transform: "translate(-16.128 -2.59)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337481",
    "data-name": "Path 337481",
    d: "M25.87,12.08,23.9,8.5h-.555V12.08H21.031V2.591h3.88a4.253,4.253,0,0,1,1.913.392,2.7,2.7,0,0,1,1.183,1.074,2.983,2.983,0,0,1,.394,1.52,2.831,2.831,0,0,1-.535,1.691,2.883,2.883,0,0,1-1.575,1.054l2.19,3.757ZM23.342,6.863h1.433a1.316,1.316,0,0,0,.953-.311,1.173,1.173,0,0,0,.318-.879,1.137,1.137,0,0,0-.318-.852,1.316,1.316,0,0,0-.953-.311H23.342Z",
    transform: "translate(-13.636 -2.59)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337482",
    "data-name": "Path 337482",
    d: "M29.185,4.443V6.361h3.1V8.146h-3.1v2.083h3.5V12.08H26.874V2.591h5.812V4.443Z",
    transform: "translate(-10.666 -2.591)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337483",
    "data-name": "Path 337483",
    d: "M34.034,4.443V6.361h3.1V8.146h-3.1v2.083h3.5V12.08H31.723V2.591h5.812V4.443Z",
    transform: "translate(-8.201 -2.591)",
    fill: "#1a2024"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG3);
export default __webpack_public_path__ + "static/media/g3.c858e1bb07c272905fdd9daf347de208.svg";
export { ForwardRef as ReactComponent };